import { ReactElement } from 'react';
import { App } from 'antd';
import { Outlet } from 'react-router-dom';
import { SessionTimerProvider } from 'features/sessionTimer';
import { UserCard } from 'features/UserCard';
import { LONG_TOAST_DURATION } from 'shared/config';
import { ToastProvider } from 'shared/ui/ToastProvider';

export function RootPage(): ReactElement {
  return (
    <App
      component={false}
      notification={{ top: 84, duration: LONG_TOAST_DURATION, placement: 'topRight', stack: false }}
    >
      <Outlet />
      <UserCard />
      <ToastProvider />
      <SessionTimerProvider />
    </App>
  );
}
